import { useRef, useEffect, useState } from 'react';

const items = [
  {
    icon: 'ri-shield-check-line',
    label: 'Licensed & Insured',
    sub: 'Fully certified professionals',
  },
  {
    icon: 'ri-award-line',
    label: 'Residential & Commercial',
    sub: 'Every project type covered',
  },
  {
    icon: 'ri-gem-line',
    label: 'Premium Materials',
    sub: 'Top-tier flooring brands',
  },
  {
    icon: 'ri-star-line',
    label: '5-Star Rated',
    sub: 'Proven client satisfaction',
  },
  {
    icon: 'ri-map-pin-line',
    label: 'Serving New Jersey',
    sub: 'Freehold & surrounding areas',
  },
];

export default function TrustBar() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="bg-charcoal" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5">
        <div className="flex flex-wrap justify-center lg:justify-between items-center gap-4 lg:gap-0">
          {items.map((item, i) => (
            <div
              key={item.label}
              className="flex items-center gap-3 px-4 py-2"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(12px)',
                transition: `opacity 0.5s ease ${i * 0.08}s, transform 0.5s ease ${i * 0.08}s`,
              }}
            >
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/5 flex-shrink-0">
                <i className={`${item.icon} text-gold text-base`}></i>
              </span>
              <div>
                <p className="text-white text-sm font-medium leading-tight">{item.label}</p>
                <p className="text-white/40 text-xs">{item.sub}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
